<template>
    <section v-if="hasPermissions(['QC-Inspection-Template Read', 'QC-Inspection-Template Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
          {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
              To create a new Inspection Template, click "Add Inspection Template".  Click the Detail icon to add or remove Room Types.
            </p>
        </div>

        <div class="bar-container mb-0">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="inspection_templates.length && hasPermissions(['QC-Inspection-Template Read'])">
                  <i class="material-icons prefix iconInput">search</i>
                  <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
              <UploadOptions
                    v-if="hasPermissions(['QC-Inspection-Template Upload'])"
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'inspection_templates_template_file'"
                    @data="upload($event)"
                    class="mb-1 mr-1 ml-0"
                />
                <UploadOptions
                    :ref="'file_excel_room_types'"
                    :empty_format_data="empty_format_data_room_types"
                    :excel_file_headers="excel_file_headers_room_types"
                    :file_name="'room_types_inspection_template_upload_template_file'"
                    :btn_label="'Room Types Upload options'"
                    id="file_excel_input_room_types"
                    @data="uploadRoomTypes($event)"
                    v-if="hasPermissions(['QC-Inspection-Template Room-Types-Upload'])"
                />
                <UploadOptions
                    :ref="'file_excel_inspection_items'"
                    :empty_format_data="empty_format_data_inspection_items"
                    :excel_file_headers="excel_file_headers_inspection_items"
                    :file_name="'inspection_items_inspection_template_upload_template_file'"
                    :btn_label="'Inspection Items Upload options'"
                    id="file_excel_input_inspection_items"
                    @data="uploadInspectionItems($event)"
                    v-if="hasPermissions(['QC-Inspection-Template Inspection-Items-Upload'])"
                />
                <button v-if="hasPermissions(['QC-Inspection-Template Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['QC-Inspection-Template Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                  <a href="#" @click="form_modal()" class="d-inline-md-block">
                      {{ add_btn }}
                      <i class="prefix ml-1">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                      </i>
                  </a>
                </span>
            </div>
        </div>

        <div class="formdynamic__item col-md-2 py-0 mb-4 mt-0">
            <div class="formdynamic__item__field">
                <label class="modal-label input-date-template">View inspection templates:</label>
                <select class="input-field custom-select" v-model="status">
                    <option :value="item.id" v-for="(item, index) in status_options" :key="index" v-html="item.name" />
                </select>
            </div>
        </div>

        <div class="tab-content mt-4" v-show="inspection_templates_list.length && hasPermissions(['QC-Inspection-Template Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                          <DinamicTable
                            :headers="table_headers"
                            :items="inspection_templates_list"
                            :search="search"
                            :checkable="true"
                            :link="'/qc-inspection-template/'"
                            :updateable="true"
                            @emitToUpdate="modal_update($event)"
                            @emitAction="emitAction($event)"
                          />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Inspection Template'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Inspection Template Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <UploadSummary
          :breadcrumb="breadcrumb"
          :summary="summary"
          :excel_file_headers="summary_headers"
          :excel_data="excel_data"
          :file_name="name_summary_file"
        />

        <DeletionValidationModal 
        :validation_table_headers="deletion_validation_table_headers"
        :validate_data="validate_data"
        :breadcrumb="breadcrumb"
        message="The following inspection templates were not deleted because there are inspections linked to them. Please note that these inspections may also be linked to items in the recycle bin."
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb                       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal                     from    '@/components/WaitingModal'
import Resources                        from    './resources'
import FormResources                    from    './form_resources.js'
import FormModal                        from    './FormModal'
import UpdateModal                      from    './UpdateModal'
import DeletionModal                    from    '@/components/DeletionModal'
import DeletionValidationModal          from    '@/components/DeletionValidationModal'
import DinamicTable                     from    '@/components/DinamicTable'
import DeletionMassiveModal             from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent            from   '@/components/UnauthorizedComponent'
import UploadSummary                    from    '@/components/UploadSummary'
import UploadOptions                    from    '@/components/UploadOptions'
import HelperModal          from    '@/components/HelperModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
  name: 'InspectionTemplate',

  components: {
    Breadcrumb,
    WaitingModal,
    DeletionModal,
    FormModal,
    UpdateModal,
    DinamicTable,
    DeletionMassiveModal,
    UnauthorizedComponent,
    UploadOptions,
    UploadSummary,
    DeletionValidationModal,
    HelperModal
  },

  data() {
    return {
      notyf,
      user:                                 this.get_user(),
      child_href:                           '/qc-inspection-template-detail/',
      title_page:                           'Inspection Templates',
      rest_api:                             `inspection_templates`,
      table_headers:                        Resources.table_headers,
      breadcrumb:                           Resources.breadcrumb,
      deletion_validation_table_headers:    Resources.deletion_validation_table_headers,
      excel_file_headers:                   Resources.excel_file_headers,
      empty_format_data:                    Resources.empty_format_data,
      excel_file_headers_room_types:        Resources.excel_file_headers_room_types,
      empty_format_data_room_types:         Resources.empty_format_data_room_types,
      excel_file_headers_inspection_items:  Resources.excel_file_headers_inspection_items,
      empty_format_data_inspection_items:   Resources.empty_format_data_inspection_items,
      status_options:                       FormResources.status_options,
      add_btn:                        'Add Inspection Template',
      single_select:                  false,
      table_selection:                [],
      search:                         '',
      global_index:                   0,
      single_object:                  {},
      inspection_templates:           [],
      array_options:      {
        room_type_id: []
      },
      select_ids:                     [],
      first_time_request:             false,
      summary_headers:                null,
      summary:                        [],
      excel_data:                     [],
      name_summary_file:              'inspection_templates_failed_template_file',
      validate_data:                  [],
      status: 1,
      helps:              Resources.helps
    }
  },

  methods: {
    
    unshift_object(new_object)
    {
      this.inspection_templates.unshift(new_object)
    },

    splice_object(splicing_object)
    {
        let found_index = this.inspection_templates.findIndex(item => item.decrypted_id === splicing_object.single_object.decrypted_id)
        if(found_index > -1)
        {
            this.inspection_templates.splice(found_index, 1, splicing_object.single_object)
        }
    },

    form_modal()
    {
      if(!this.user.has_facility){
        notyf.error('There is not exists a facility yet')
        return false
      }
      this.array_options.room_type_id.forEach(item => item.checked = false)
      window.$('#static').modal('show')
    },

    modal_deletion(index)
    {
      this.global_index  = index
      this.single_object = this.inspection_templates_list[index]
      window.$('#static-deletion').modal('show')
    },

    modal_update(index)
    {
      this.global_index  = index
      this.single_object = this.inspection_templates_list[index]
      window.$('#static-update').modal('show')
    },

    emitAction({index})
    {
      this.modal_update(index)
    },

    fill_data(data)
    {
      this.inspection_templates = data.inspection_templates
      this.array_options = {
        room_type_id: data.room_types,
        inspection_type_id: data.inspection_types
      }
    },

    trashing(index)
    {
      this.inspection_templates_list.splice(index, 1)
    },

    massive_modal_delete()
    {
      this.select_ids = this.inspection_templates_list.filter(item => item.checked).map(item => item.id)
      if(this.select_ids.length)
      {
        window.$('#static-deletion-massive').modal('show')
      }
    },

    async massive_local_emition()
    {
        let json_request = {
            ids: this.select_ids,
        }

        this.loader(true)

        let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

        this.loader()

        if(response.status)
        {
            const validation_data = response.data.deletion_validations

            if(validation_data.length)
            {
                window.$('#deletion-validations').modal('show')
                this.validate_data = validation_data
            }

            window.$('#static-deletion-massive').modal('hide')

            response.data.deleted_ids.forEach( item =>
            {
                const index = this.inspection_templates_list.findIndex(value => value.decrypted_id == item)
                if(index > -1)
                {
                    this.inspection_templates_list.splice(index, 1)
                }
            })
            this.select_ids = []
        }
    },

    async upload(data)
    {
        this.excel_data = data

        this.loader(true)
        const response = await this.post(`${this.rest_api}/massive`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
        this.loader()

        if(response.status)
        {
            if(response.data.is_queue)
            {
                notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                return;
            }

            notyf.success('Success!')
            this.summary_headers = this.excel_file_headers
            this.summary = response.data.summary
            this.name_summary_file = 'inspection_templates_failed_template_file'
            window.$('#upload-summary').modal('show')
        }
        else
        {
            this.error_handling(response)
        }

        this.api_request()
        
        this.$refs.file_excel.clear_data()
    },

    async uploadRoomTypes(data)
    {
      this.excel_data = data

        this.loader(true)
        const response = await this.post(`${this.rest_api}/massive_room_types`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
        this.loader()

        if(response.status)
        {
            if(response.data.is_queue)
            {
                notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                return;
            }

            notyf.success('Success!')
            this.summary_headers = this.excel_file_headers_room_types
            this.summary = response.data.summary
            this.name_summary_file = 'room_types_inspection_template_failed_template_file'
            window.$('#upload-summary').modal('show')
        }
        else
        {
            this.error_handling(response)
        }

        this.api_request()
        
        this.$refs.file_excel_room_types.clear_data()
    },

    async uploadInspectionItems(data)
    {
      this.excel_data = data

      this.loader(true)
      const response = await this.post(`${this.rest_api}/massive_inspection_items`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
      this.loader()

      if(response.status)
      {
          if(response.data.is_queue)
          {
              notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
              return;
          }

          notyf.success('Success!')
          this.summary_headers = this.excel_file_headers_inspection_items
          this.summary = response.data.summary
          this.name_summary_file = 'inspection_items_inspection_template_failed_template_file'
          window.$('#upload-summary').modal('show')
      }
      else
      {
          this.error_handling(response)
      }

      this.api_request()

      this.$refs.file_excel_inspection_items.clear_data()
    }
  },

  async mounted() {
    if(this.hasPermissions(['QC-Inspection-Template Read', 'QC-Inspection-Template Write']))
    {
      await this.api_request()
    }
  },

  computed:
  {
    selected()
    {
      const bool = this.inspection_templates_list.filter(item => item.checked)
      return Boolean(bool.length)
    },

    inspection_templates_list()
    {
        if(this.status !== 3)
        {
            const inspection_templates = this.inspection_templates.filter(item => item.status == this.status)
            return inspection_templates
        }

        return this.inspection_templates
    }
  },

}

</script>
